// frontend/src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpBackend) // Loads translations from /public/locales
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    supportedLngs: ["he", "en"], // Define supported languages
    fallbackLng: "en", // Fallback language if detected language is not supported
    defaultNS: "translation", // Default namespace for translations
    ns: ["common", "translation", "pwa"], // Preload these namespaces
    debug: import.meta.env.MODE === "development", // Enable debug output in development

    detection: {
      // Order and from where user language should be detected
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage"], // Cache the language in localStorage
    },
    lng: "en", // Set default language to English

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Path to translation files
      // Disable caching in development to ensure fresh translations
      reloadInterval: import.meta.env.MODE === "development" ? false : 3600000, // Disable caching in development to ensure fresh translations
      // Add cache busting in development
      queryStringParams:
        import.meta.env.MODE === "development" ? { v: Date.now() } : {}, // Add cache busting in development
    },

    react: {
      useSuspense: true, // Recommended for loading translations
    },
  });

// Make i18n globally accessible for testing
if (typeof window !== "undefined") {
  window.i18next = i18n;
  window.reactI18next = { useTranslation: () => ({ t: (key) => key, i18n }) };
}

export default i18n;
